import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { PanelDetailLocationsService } from '../../../../services/Panel-Detail-Locations.service';

@Component({
  selector: 'details-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.css']
})
export class SkeletonLoaderComponent {

  fullScreen: boolean = false;

  mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;
  
    constructor(
      changeDetectorRef: ChangeDetectorRef,
      media: MediaMatcher,
      private panelDetalilService: PanelDetailLocationsService
    ) {
      this.mobileQuery = media.matchMedia("(min-width: 769px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    }

    CancelButton(){

    this.panelDetalilService.setLoading(false);
    this.panelDetalilService.setVisibilityPopup(false);
  }

}
